// VFX: Chromatic Aberration
// Slug: fx_chromatic-aberration_rgb-shift_loop
// Category: overlays
import { AbsoluteFill, useCurrentFrame } from "remotion";
import React from "react";

type Props = { intensity?: number; text?: string };

export default function FxChromaticAberrationRgbShiftLoop({
  intensity = 1,
  text = "SIGNAL LOST",
}: Props) {
  const frame = useCurrentFrame();
  const t = frame * 0.08;
  const rx = Math.sin(t) * 12 * intensity;
  const gx = Math.sin(t + Math.PI / 2) * 8 * intensity;
  const bx = Math.cos(t * 1.3) * 14 * intensity;
  const ry = Math.cos(t * 0.7) * 6 * intensity;
  const by = Math.sin(t * 0.9) * 6 * intensity;

  const sharedStyle: React.CSSProperties = {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "system-ui, sans-serif",
    fontWeight: 900,
    fontSize: 140,
    letterSpacing: 4,
    mixBlendMode: "screen",
  };

  return (
    <AbsoluteFill style={{ background: "#000" }}>
      <div style={{ ...sharedStyle, color: "#ff0044", transform: `translate(${rx}px, ${ry}px)` }}>{text}</div>
      <div style={{ ...sharedStyle, color: "#00ff88", transform: `translate(${gx}px, 0)` }}>{text}</div>
      <div style={{ ...sharedStyle, color: "#0066ff", transform: `translate(${bx}px, ${by}px)` }}>{text}</div>
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "repeating-linear-gradient(0deg, rgba(255,255,255,0.04) 0 1px, transparent 1px 3px)",
          mixBlendMode: "overlay",
        }}
      />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
